import { type ReactNode } from 'react';
import { HStack, Text, VStack } from '@direct-frontend/components';
import styles from './CheckoutCharacteristic.module.css';

interface CheckoutCharacteristicGroupProps {
    children: ReactNode;
}

export const CheckoutCharacteristicGroup = ({ children }: CheckoutCharacteristicGroupProps) => {
    if (!children) {
        return null;
    }

    return (
        <VStack className={styles.group} gap="16">
            {children}
        </VStack>
    );
};

interface CheckoutCharacteristicProps {
    title: string;
    content?: string | null;
}

export const CheckoutCharacteristic = ({ title, content }: CheckoutCharacteristicProps) => {
    if (!content) {
        return null;
    }

    return (
        <HStack className={styles.characteristic} justifyContent="space-between" gap="8">
            <Text size="mc" role="supplementary" className={styles.title}>
                {title}
            </Text>
            <Text size="mc" textAlign="right">
                {content}
            </Text>
        </HStack>
    );
};
